import * as React from 'react';
import { BaseComponent } from './BaseComponent';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { DebugActions } from '../actions/DebugActions';
import { AppFileApiHelper } from '../utils/AppFileApiHelper';

// Submodules
import * as AppFileApiWrapper from '../submodules/app-api/Filesystem/Wrapper';

import utils = egr.wcf.utils;

interface FileListProps extends React.Props<FileList> {}

interface FileListState {
    list: Array<string>;
    currentPath: string;
    pending: boolean;
    error: string | null;
}

export class FileList extends BaseComponent<FileListProps, FileListState> {
    public static compareEntry(first: string, second: string): number {
        if (first.slice(-1) === '/') {
            if (second.slice(-1) !== '/') {
                return -1;
            }
        } else if (second.slice(-1) === '/') {
            return 1;
        }

        return first.localeCompare(second);
    }

    public componentWillMount(): void {
        this.updatePath('/', true);
    }

    public render(): JSX.Element {
        const backPath: string = this.state.currentPath.split('/').slice(0, -2).join('/') + '/';
        return (
            <ul>
                <li>Current Path: {this.state.currentPath}&nbsp;<b onClick={this.downloadFolder}>Download</b></li>
                {this.state.pending ? <li>... pending ...</li> : null}
                {this.state.error ? <li>{this.state.error}</li> : null}
                {this.state.currentPath !== '/' ?
                    <li style={{cursor: 'pointer'}}  onClick={this.leavePath}>Back to {backPath}</li> : null}
                {this.state.list.sort(FileList.compareEntry).map(this.getEntry)}
            </ul>
        );
    }

    protected downloadFolder = () => {
        ViewSettingsActions.withLock<void>(() => {
            return DebugActions.exportFolder(this.state.currentPath);
        });
    };

    protected leavePath = () => {
        const backPath: string = this.state.currentPath.split('/').slice(0, -2).join('/') + '/';
        if (!this.state.pending) {
            this.updatePath(backPath);
        }
    };

    protected enterPath = (listItem: string) => () => {
        if (!this.state.pending) {
            this.updatePath(this.state.currentPath + listItem);
        }
    };

    protected downloadFile = (listItem: string) => () => {
        AppFileApiHelper.readBinaryFile(this.state.currentPath + listItem).then((data: ArrayBuffer): void => {
            const listItemParts: Array<string> = listItem.split('/');
            const element: HTMLAnchorElement = document.createElement('a');
            element.setAttribute('href', utils.arraybuffer.toDataUri(data, 'application/octet-stream'));
            element.setAttribute('download', listItemParts[listItemParts.length - 1]);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        });
    };

    protected getEntry = (listItem: string, index: number): JSX.Element => {
        if (listItem.endsWith('/')) {
            return (
                <li style={{cursor: 'pointer'}} key={index} onClick={this.enterPath(listItem)}>
                    {listItem}
                </li>
            );
        }
        return <li style={{cursor: 'pointer'}} key={index} onClick={this.downloadFile(listItem)}>{listItem}</li>;
    };

    protected updatePath(newPath: string, init: boolean = false): void {
        if (init) {
            this.setState({list: [], currentPath: newPath, pending: true, error: null});
        } else {
            this.setState({...this.state, pending: true, error: null});
        }
        AppFileApiWrapper.list(newPath).then(
            (list: Array<string>) => { this.setState({list: list, currentPath: newPath, pending: false, error: null}); },
            (what) => { this.setState({...this.state, pending: false, error: what}); }
        ).catch((e) => {
            this.setState({...this.state, pending: false, error: e});
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FileList.tsx